/**
 * @generated SignedSource<<29e2876be90b270a1cda50edada8d424>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCardAttendeesSection_event$data = {
  readonly attendingInPerson: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly user: {
          readonly id: string;
          readonly primaryPhoto: {
            readonly id: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhoto_user">;
        } | null | undefined;
      };
    }>;
    readonly totalCount: number;
  };
  readonly attendingVirtually: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly user: {
          readonly id: string;
          readonly primaryPhoto: {
            readonly id: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhoto_user">;
        } | null | undefined;
      };
    }>;
    readonly totalCount: number;
  };
  readonly endAt: string;
  readonly waiting: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly user: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhoto_user">;
        } | null | undefined;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "EventCardAttendeesSection_event";
};
export type EventCardAttendeesSection_event$key = {
  readonly " $data"?: EventCardAttendeesSection_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardAttendeesSection_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "UserPrimaryPhoto_user"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardAttendeesSection_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": "attendingInPerson",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "status": "ATTENDING_IN_PERSON"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendeesByRelevance",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:5)"
    },
    {
      "alias": "attendingVirtually",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "status": "ATTENDING_VIRTUAL"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendeesByRelevance",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:5)"
    },
    {
      "alias": "waiting",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "status": "WAITING_IN_PERSON"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendeesByRelevance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventAttendeesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventAttendee",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"WAITING_IN_PERSON\"},first:5)"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "9e5e1726908cec8d0f579e7e27b1193b";

export default node;
